/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from '../runtime';
import { ApiCSVRowFromJSON, ApiCSVRowToJSON, } from './ApiCSVRow';
export function ApiCSVMappingResponseFromJSON(json) {
    return ApiCSVMappingResponseFromJSONTyped(json, false);
}
export function ApiCSVMappingResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'headers': !exists(json, 'headers') ? undefined : json['headers'],
        'mapping': !exists(json, 'mapping') ? undefined : (mapValues(json['mapping'], ApiCSVRowFromJSON)),
        'rows': !exists(json, 'rows') ? undefined : (json['rows'].map(ApiCSVRowFromJSON)),
        'userValue': !exists(json, 'userValue') ? undefined : json['userValue'],
    };
}
export function ApiCSVMappingResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'headers': value.headers,
        'mapping': value.mapping === undefined ? undefined : (mapValues(value.mapping, ApiCSVRowToJSON)),
        'rows': value.rows === undefined ? undefined : (value.rows.map(ApiCSVRowToJSON)),
        'userValue': value.userValue,
    };
}
